<template>
    <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">{{ question.name }}</h4>
        <h4 class="mb-0 text-muted">{{ question.step }} / {{ totalQuestions }}</h4>
      </div>
      <div class="card-body answer-quizz">
        <div class="d-flex justify-content-center" v-if="question.proposal_type === 'multiple_choice'">
          <div class="alert alert-info text-center mb-4" role="alert">
            Vous pouvez sélectionner plusieurs réponses.
          </div>
        </div>
        <div class="d-flex justify-content-center" v-if="question.proposal_type === 'simple_choice'">
          <div class="alert alert-info text-center mb-4" role="alert">
            Vous devez sélectionner une réponse.
          </div>
        </div>
         <div class="d-flex justify-content-center" v-if="question.proposal_type === 'ordered'">
          <div class="alert alert-info text-center mb-4" role="alert">
            Vous devez classer l'ordre des réponses.
          </div>
        </div>
        <ul class="list-group list-group-flush text-center bg-light">
          <li class="list-group-item" v-for="(proposal, index) in randomProposals" :key="index">
            <div v-if="question.proposal_type === 'multiple_choice'">
              <input type="checkbox" class="form-check-input" :id="proposal.name" :value="proposal.value" v-model="answers">
              <label class="form-check-label" :for="proposal.name">{{ proposal.name }}</label>
            </div>
            <div v-if="question.proposal_type === 'simple_choice'">
              <input class="form-check-input" type="radio" name="choice" :id="proposal.name" :value="proposal.value" v-model="answers">
              <label class="form-check-label" :for="proposal.name">{{ proposal.name }}</label>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-center" v-if="question.proposal_type === 'ordered'">
              <select class="custom-select mb-2" :id="proposal.name" style="width: auto;" @change="handleOrdered($event, proposal.value)" :value="getOrderedValue(proposal.value)">
                <option :value="number" v-for="number in randomProposals.length" :key="`ordered-${number}`">{{ number }}</option>
              </select>
              <label class="form-check-label" :for="proposal.name">{{ proposal.name }}</label>
            </div>
          </li>
        </ul>
        <button type="button" class="btn btn-primary btn-lg btn-block mt-4" :disabled="submitDisabled" @click="submitAnswer()">
          <span class="d-flex justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="loading"></span> Soumettre
          </span>
        </button>
      </div>
    </div>
</template>


<script>
export default {
  props: {
    question: Object,
    totalQuestions: Number
  },

  data() {
    return {
      answers: [],
      loading: false,
    }
  },

  watch: {
    question() {
      this.answers = []
    }
  },

  computed: {
    submitDisabled() {
      return this.loading || this.answers.length === 0
    },

    randomProposals() {
      if (this.question && this.question.proposals && this.question.proposals.length) {
        return this.question.proposals.sort(() => Math.random() - 0.5)
      }

      return []
    }
  },

  methods: {
    getOrderedValue(proposal) {
      const answer = this.answers.find((a) => a.proposal === proposal)

      if (answer) {
        return answer.order
      }
    },

    handleOrdered(event, proposal) {
      const obj = { proposal, order: event.target.value }

      const answerIndex = this.answers.findIndex((a) => a.order === obj.order && a.proposal !== proposal)
      const proposalIndex = this.answers.findIndex((a) => a.proposal === proposal)

      // The Proposal has already a value in the answers
      if (proposalIndex >= 0) {
        this.answers.splice(proposalIndex, 1)
      }

      // The Order is already set for a another answer
      if (answerIndex >= 0) {
        this.answers.splice(answerIndex, 1)
      }

      this.answers.push(obj)
    },

    submitAnswer() {
      if (this.submitDisabled) {
        return
      }

      this.loading = true;

      axios.post(`/webapi/questions/${this.question.id}/answer`, {
        answers: this.answers,
      })
      .then((res) => {
        this.$emit('next', this.question)
      })
      .catch((err) => console.log(err))
      .finally(() => this.loading = false)
    }
  },

  mounted() {
    this.answers = []
  }
}
</script>
